import { useState } from 'react'
import { Trans } from '@lingui/macro'
import { Button, MenuItem } from '@mui/material'
import PersonAddRoundedIcon from '@mui/icons-material/PersonAddRounded'

import { useGetPatientQuery } from '@/core/services/patient'
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'

import { useCreatePatientAccount } from '../../model/useCreatePatientAccount'
import { CreatePatientAccountDialog } from './CreatePatientAccountDialog'

type CreatePatientAccountProps = {
  onClose?: () => void
  patientId: string
}

export function CreatePatientAccount({ patientId, onClose }: CreatePatientAccountProps) {
  const isLargeScreen = useIsLargeScreen()

  const { data: patient } = useGetPatientQuery(patientId)
  const createPatientAccount = useCreatePatientAccount(patientId, onClose)
  const [dialogOpen, setDialogOpen] = useState(false)

  if (!patient || !!patient.account) return null

  const handleClick = () => {
    setDialogOpen(true)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
    onClose?.()
  }

  return (
    <>
      {isLargeScreen ? (
        <Button startIcon={<PersonAddRoundedIcon />} onClick={handleClick} variant="contained">
          <Trans>Create patient account</Trans>
        </Button>
      ) : (
        <MenuItem onClick={handleClick} disableRipple>
          <PersonAddRoundedIcon />
          <Trans>Create patient account</Trans>
        </MenuItem>
      )}
      <CreatePatientAccountDialog open={dialogOpen} onClose={handleDialogClose} patient={patient} onAccountCreated={createPatientAccount} />
    </>
  )
}
